const MAX_TIMEOUT = 0x7FFFFFFF;

export const promise = async <T>(
  executor: (resolve: (value: T | PromiseLike<T>) => void, reject: (reason?: any) => void) => void,
  timeout: number = MAX_TIMEOUT
): Promise<T> => {
  return await Promise.race([
    new Promise<T>(executor),
    new Promise<never>((_, reject) => {
      setTimeout(() => reject('promise timed out'), timeout)
    })
  ]);
}
